import { render, staticRenderFns } from "./CollegeCourseRedirect.vue?vue&type=template&id=d331b8c6&scoped=true&"
import script from "./CollegeCourseRedirect.vue?vue&type=script&lang=js&"
export * from "./CollegeCourseRedirect.vue?vue&type=script&lang=js&"
import style0 from "./CollegeCourseRedirect.vue?vue&type=style&index=0&id=d331b8c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d331b8c6",
  null
  
)

export default component.exports